import MessageLayout from './MessageLayout';
import notesIcon from '../assets/Notes.svg';
import seriesIcon from '../assets/Series.svg';
import messageIcon from '../assets/Letter.png';
import { getTranslations } from '../utils/translations';

const mobileButtonStyle = {
    backgroundColor: 'rgba(43, 51, 63, 0.7)',
    borderRadius: '0.3em',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    textDecoration: 'none',
    border: 'none',
};

const iconStyle = {
    width: '24px',
    height: '24px',
    filter: 'brightness(0) invert(1)'
};

function SeriesPlayerView({ playlist, currentPlaylistItem, videoRef, playlistContainerRef, isMobile, isAdPlaying }) {
    const t = getTranslations();
    const isVideoContent = currentPlaylistItem?.mediaType === 'video';
    console.log('🎨 SeriesPlayerView isAdPlaying:', isAdPlaying);
    return (
      <div id="series-player" className={`${isVideoContent ? 'is-video-content' : ''}${isAdPlaying ? ' ad-playing' : ''}`} style={{display: 'flex', flexDirection: 'column'}}>
        <div className='series-player-header'>
          <div className="video-container" style={{ position: 'relative' }}>
            <div data-vjs-player>
              <video ref={videoRef} poster={currentPlaylistItem?.poster} className="video-js vjs-big-play-centered" />
            </div>
            {isMobile && (
                <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    zIndex: 2,
                    display: 'flex',
                    gap: '10px'
                }}>
                    {currentPlaylistItem?.notes?.includes('https') && (
                        <a href={currentPlaylistItem.notes} target="_blank" rel="noreferrer" style={mobileButtonStyle} title={t.downloadBibleStudy}>
                            <img src={notesIcon} alt={t.bibleStudy} style={iconStyle} />
                        </a>
                    )}
                    {currentPlaylistItem?.message?.includes('https') && (
                        <a href={currentPlaylistItem.message} target="_blank" rel="noreferrer" style={mobileButtonStyle} title={currentPlaylistItem?.mediaType === 'video' ? t.buyVideo : t.buyMessage}>
                            <img src={messageIcon} alt={currentPlaylistItem?.mediaType === 'video' ? t.video : t.message} style={iconStyle} />
                        </a>
                    )}
                    {currentPlaylistItem?.series?.includes('https') && (
                        <a href={currentPlaylistItem.series} target="_blank" rel="noreferrer" style={mobileButtonStyle} title={currentPlaylistItem?.messageSpeaker === 'Paws & Tales' ? t.buySeason : t.buySeries}>
                            <img src={seriesIcon} alt={currentPlaylistItem?.messageSpeaker === 'Paws & Tales' ? t.series : t.series} style={iconStyle} />
                        </a>
                    )}
                </div>
            )}
          </div>
          <MessageLayout playlist={playlist} message={currentPlaylistItem} />
        </div>
        {playlist.length > 1 && <div ref={playlistContainerRef} className="vjs-playlist playlist-layout" />}
      </div>
    );
}
export default SeriesPlayerView;